export const GET_DASHBOARD_TASKS_LOADING = 'GET_DASHBOARD_TASKS_LOADING';
export const GET_DASHBOARD_TASKS_SUCCESS = 'GET_DASHBOARD_TASKS_SUCCESS';
export const GET_DASHBOARD_TASKS_FAILURE = 'GET_DASHBOARD_TASKS_FAILURE';

export const ADD_DASHBOARD_TASK_LOADING = 'ADD_DASHBOARD_TASK_LOADING';
export const ADD_DASHBOARD_TASK_SUCCESS = 'ADD_DASHBOARD_TASK_SUCCESS';
export const ADD_DASHBOARD_TASK_FAILURE = 'ADD_DASHBOARD_TASK_FAILURE';

export const UPDATE_DASHBOARD_TASK_LOADING = 'UPDATE_DASHBOARD_TASK_LOADING';
export const UPDATE_DASHBOARD_TASK_SUCCESS = 'UPDATE_DASHBOARD_TASK_SUCCESS';
export const UPDATE_DASHBOARD_TASK_FAILURE = 'UPDATE_DASHBOARD_TASK_FAILURE';

export const DELETE_DASHBOARD_TASK_LOADING = 'DELETE_DASHBOARD_TASK_LOADING';
export const DELETE_DASHBOARD_TASK_SUCCESS = 'DELETE_DASHBOARD_TASK_SUCCESS';
export const DELETE_DASHBOARD_TASK_FAILURE = 'DELETE_DASHBOARD_TASK_FAILURE';

export const GET_DASHBOARD_TASK_BY_ID_LOADING = 'GET_DASHBOARD_TASK_BY_ID_LOADING';
export const GET_DASHBOARD_TASK_BY_ID_SUCCESS = 'GET_DASHBOARD_TASK_BY_ID_SUCCESS';
export const GET_DASHBOARD_TASK_BY_ID_FAILURE = 'GET_DASHBOARD_TASK_BY_ID_FAILURE';

export const LOAD_TABLE_COLUMN_PREFERENCES_LOADING = 'LOAD_TABLE_COLUMN_PREFERENCES_LOADING';
export const LOAD_TABLE_COLUMN_PREFERENCES_SUCCESS = 'LOAD_TABLE_COLUMN_PREFERENCES_SUCCESS';
export const LOAD_TABLE_COLUMN_PREFERENCES_FAILURE = 'LOAD_TABLE_COLUMN_PREFERENCES_FAILURE';

export const UPDATE_TABLE_COLUMN_PREFERENCES_LOADING = 'UPDATE_TABLE_COLUMN_PREFERENCES_LOADING';
export const UPDATE_TABLE_COLUMN_PREFERENCES_SUCCESS = 'UPDATE_TABLE_COLUMN_PREFERENCES_SUCCESS';
export const UPDATE_TABLE_COLUMN_PREFERENCES_FAILURE = 'UPDATE_TABLE_COLUMN_PREFERENCES_FAILURE';

export const SET_DASHBOARD_VIEW_MODE = 'SET_DASHBOARD_VIEW_MODE';
export const SET_ALL_TASK_SELECTED = 'SET_ALL_TASK_SELECTED';
export const CLEAR_ALL_TASK_SELECTION = 'CLEAR_ALL_TASK_SELECTION';
export const SET_SINGLE_TASK_SELECTED = 'SET_SINGLE_TASK_SELECTED';
export const RESET_DASHBOARD_TASKS = 'RESET_DASHBOARD_TASKS'; // New action type for resetting tasks
